import React from 'react';
import './components.css';

const Help = () => (
  <div className="container-2025 section-2025 prose-2025">
    <h2 className="help-header flex items-center gap-2 text-2xl font-semibold">
      <i className="fas fa-info-circle text-indigo-500"></i>
      Help & Getting Started
    </h2>

    <p>Welcome! This guide walks you through creating and managing your workouts.</p>

    <ol className="list-decimal list-inside space-y-2 mt-4 text-[16px]">
      <li>After signing in, you’ll land on the <strong>Home</strong> screen.</li>
      <li>Select the <strong>New Workout</strong> icon.</li>
      <li>Enter a <strong>title</strong> and <strong>description</strong>, then click <em>Create Workout</em>.</li>
      <li>Once your workout is created, you’ll return to the Home screen — click your new workout to open it.</li>
      <li>Below your workout details, click the green <em>Add Exercise</em> button to include a new exercise.</li>
      <li>Fill out the exercise form with a name and submit it using <em>Add Exercise</em>.</li>
      <li>Use <em>Edit Workout</em> to update the name or description, or <em>Delete</em> to remove it entirely.</li>
      <li>Open your exercise to view its details, edit/delete options, and a form for logging repetitions.</li>
      <li>To log a set, enter a number greater than 0 in the form and click <em>Log Set</em>.</li>
      <li>To edit or delete a set, click <em>Edit</em> (to modify) or <em>Delete</em> (to remove it permanently).</li>
    </ol>

    <p className="mt-6 text-zinc-600 dark:text-zinc-400">
      Tip: All changes save instantly. You can always revisit a workout or exercise to make updates later.
    </p>
  </div>
);

export default Help;
